import * as messageTypes from '../message/messageTypes';

export const getMessage = (payload) => ({
  type: messageTypes.GET_MESSAGES,
  payload
});
